import React from 'react';
import styled from '../../theme/styled';

//Row
interface RowProps {
    justify_content: string;
    className: string;
    reverse: boolean;
}

const RowContainer = styled.div<RowProps>`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    height: auto;
    justify-content: ${props => props.justify_content};
    @media only screen and (max-width: 1200px) {
        flex-direction: ${props => props.reverse ? "column-reverse" : "column"};
    }
    `;

export class Row extends React.Component<RowProps> {
    public static defaultProps = {
        justify_content: "space-around",
        className: "",
        reverse: false,
    };

    render() {
        return (<RowContainer reverse={this.props.reverse} className={this.props.className} justify_content={this.props.justify_content}>{this.props.children}</RowContainer>);
    }
}


//Column
interface ColumnProps {
    width: string;
    margin: string;
    text_align: string;
    display_on_mobile: boolean;
    padding_on_mobile: boolean;
}

const ColumnContainer = styled.div<ColumnProps>`
    width: ${props => props.width}%;
    margin: ${props => props.margin};
    position: relative;
    text_align: ${props => props.text_align};
    @media only screen and (max-width: 1200px) {
        width: 100%;
        ${props => props.display_on_mobile ? "" : "display: none;"}
        padding: ${props => props.padding_on_mobile ? "40px 0;" : "0;"}
    }
    `;

export class Column extends React.Component<ColumnProps> {
    public static defaultProps = {
        margin: "0px",
        text_align: "left",
        display_on_mobile: true,
        padding_on_mobile: true,
    };

    render() {
        return (<ColumnContainer padding_on_mobile={this.props.padding_on_mobile} display_on_mobile={this.props.display_on_mobile} text_align={this.props.text_align} width={this.props.width} margin={this.props.margin}>{this.props.children}</ColumnContainer>);
    }
}

//Spacer
interface SpacerProps {
	height: string;
	display_on_mobile: boolean;
	display_on_desktop: boolean;
}

const SpacerContainer = styled.div<SpacerProps>`
	width: 100%;
    height: ${props => props.height}px;
    ${props => props.display_on_desktop ? "display: block" : "display: none"};
    @media only screen and (max-width: 1200px) {
        ${props => props.display_on_mobile ? "display: block" : "display: none"};
    }
`;

export class Spacer extends React.Component<SpacerProps> {
    public static defaultProps = {
        display_on_desktop: true,
        display_on_mobile: true,
    };

    render() {
        return <SpacerContainer
            height={this.props.height}
            display_on_desktop={this.props.display_on_desktop}
            display_on_mobile={this.props.display_on_mobile}
        />;
    }
}



// WEBPACK FOOTER //
// ./src/components/base/Layout.tsx